<div class='modal-header'>
  <h4 class='modal-title'>
    {{ title }}
  </h4>
</div>

<div class='modal-body' style='height: 300px'>
  <pt-widget-checkbox-v0-tree
    (changeSelectedRowId)="changeSelectedRowId($event)"
    [checkbox]="checkbox"
    [showShowOnlySelectedFilter]="showShowOnlySelectedFilter">
  </pt-widget-checkbox-v0-tree>
</div>

<div class='modal-footer'>
  <div class='d-flex justify-content-end'>
    <button (click)='apply()' class='btn btn-primary btn-sm me-2'
            type='button'>
      {{ 'BUTTON.APPLY' | translate }}
    </button>
    <button (click)='close()' class='btn btn-outline-secondary btn-sm' ngbAutofocus
            type='button'>
      {{ 'BUTTON.CANCEL' | translate }}
    </button>
  </div>
</div>
